/* @ngInject */
function headerFilterService () {
  let value

  const service = {
    getValue,
    setValue
  }
  return service

  function getValue () {
    return value
  }

  function setValue (obj) {
    value = obj
  }
}

export { headerFilterService }
